// extracted by mini-css-extract-plugin
module.exports = {"axisX":"MiniTransferGraphD3_axisX__rG7Pb","line":"MiniTransferGraphD3_line__97FxM","shadowLine":"MiniTransferGraphD3_shadowLine__1pCN1"};